import { FunctionComponent } from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookMessengerShareButton,
  EmailShareButton
} from 'next-share'
import DarkIconButton from '@/components/ui/Buttons/SecondaryIconButton'
import useIntl from '@/utils/intl'
import { resolveImageUrl } from '@/utils/constants'

interface Social {
  component: any
  icon: string
}

const socials: Social[] = [
  {
    component: FacebookShareButton,
    icon: '/uploads/icons/Facebook.svg'
  },
  {
    component: TwitterShareButton,
    icon: '/uploads/icons/twitter.svg'
  },
  {
    component: FacebookMessengerShareButton,
    icon: '/uploads/icons/messenger.svg'
  },
  {
    component: EmailShareButton,
    icon: '/uploads/icons/email-icon.png'
  }
]
interface Prop {
  url: string
  quote: string
  hashtag: string
}
const SocialShare: FunctionComponent<Prop> = ({ url, quote, hashtag }) => {
  const { translate } = useIntl()
  return (
    <div className='flex flex-col items-center justify-center'>
      <span className='text-textMid text-sm lg:text-base'>{translate('share')}</span>
      <div className='flex gap-2 mt-3'>
        {socials.map((item: Social, i: number) => {
          const { icon, component: Component } = item
          return (
            <Component key={i} url={url} quote={quote} hashtag={hashtag}>
              <DarkIconButton roundedFull size='sm' iconImg={resolveImageUrl(icon)} />
            </Component>
          )
        })}
      </div>
    </div>
  )
}

export default SocialShare
